// see docs/DINT_GRINT_states.pdf, docs/DynniqTrafficlightdataService_ver1_2.pdf
const greens = ["1", "3", "4", "5", "6", "7", "8", ":"];
const amber_malfunction = ["="];
const amber_flashing = [";"];
const amber_changing = ["<", ">", "I"];
const ambers = amber_changing.concat(amber_flashing, amber_malfunction);
const reds = ["9", "?", "@", "A", "B", "C", "D", "E", "F", "G", "H", "J"];
const amberReds = ["0"];
const undefineds = [".", "2"];
const GREEN = 'green', AMBER = 'amber', RED = 'red', AMBER_REDS = 'amber_red', UNDEF = 'undef';

const stateDescriptions = {
    "0": {
        "short": "Red/Amber",
        "long": "Red/Amber",
        "DV8": "RED AMBER"
    },
    "1": {
        "short": "Minimum green",
        "long": "Fixed green time. The minimum green time that is always honored.",
        "DV8": "MINIMUM GREEN"
    },
    "2": {
        "short": "(not used), same as \".\"",
        "long": "Not used, same as \".\"",
        "DV8": "-"
    },
    ".": {
        "short": "(not used), same as \"2\"",
        "long": "Not used, same as \"2\"",
        "DV8": "-"
    },
    "3": {
        "short": "Vehicle actuated minimum green",
        "long": "Extension of the minimum green time up to maximum-minimum-green",
        "DV8": "MINIMUM GREEN > MINIMUM GREEN"
    },
    "4": {
        "short": "Passive Green",
        "long": "1. All regular extensions of the signal group green state have expired and there is a demand for a conflicting signal group. The signal group may be in this state because it is being extended in parallel with another signal-group. 2. rest mode green for green in the main directions.",
        "DV8": "REST GREEN"
    },
    "5": {
        "short": "Green extension",
        "long": "Extension of the green time up to maximum green.",
        "DV8": "MAXIMUM GREEN"
    },
    "6": {
        "short": "Green extension by local co-ordination",
        "long": "Extension of green by means of special fixed-demand mode of operation (SE: Tidstyrd). This state replaces states '4' and '5' if this mode of operation is active.",
        "DV8": "REST GREEN + MAXIMUM GREEN"
    },
    "7": {
        "short": "Fixed Past-end-green",
        "long": "Fixed amount of extra green when the signal group is being ended.",
        "DV8": "FIXED PAST END GREEN"
    },
    "8": {
        "short": "Vehicle actuated past-end-green",
        "long": "Variable amount of extra green when the signal group is being ended.",
        "DV8": "VARIABLE PAST END GREEN"
    },
    "9": {
        "short": "Red Synchronization",
        "long": "Signal group is red with a demand to go to green and all clearance times have expired. The signal group realization is being delayed because a delay must be obeyed with respect to the realization of another signal group. This state is entered immediately following the synchronization point with the group for which it is waiting.",
        "DV8": "ACTIVE RED"
    },
    ":": {
        "short": "Green blinking",
        "long": "Green blinking state for the signal group",
        "DV8": "Pedestrian: FIX AMB + VAR AMB\nVehicle: n.a."
    },
    ";": {
        "short": "Amber flashing",
        "long": "Amber flashing as part of the controller plan.",
        "DV8": "-"
    },
    "<": {
        "short": "Fixed Amber",
        "long": "Fixed amber state following green",
        "DV8": "FIX AMB"
    },
    "=": {
        "short": "Amber/dark",
        "long": "Controller is in amber flashing or dark due to a malfunction",
        "DV8": "-"
    },
    ">": {
        "short": "Variable amber after green",
        "long": "Vehicle actuated amber",
        "DV8": "VAR AMB"
    },
    "?": {
        "short": "Variable red time after expiration of Minimum red",
        "long": "Vehicle actuated minimum red",
        "DV8": "VAR RED"
    },
    "@": {
        "short": "Red clearance interval",
        "long": "The signal group is in red and there is no request for the realization of this signal group. The minimum red and vehicle actuated minimum red times have expired, but the signal group MUST stay on red due to a clearance interval with respect to a different group which is longer than the defined minimum time.",
        "DV8": "PASSIVE RED"
    },
    "A": {
        "short": "Minimum red",
        "long": "Fixed minimum red time after amber",
        "DV8": "FIX RED"
    },
    "B": {
        "short": "Passive red",
        "long": "During red when no demand is present for this signal group and all clearance times have expired.",
        "DV8": "PASSIVE RED"
    },
    "C": {
        "short": "Red request",
        "long": "Signal group is red and a demand for this signal group is present. This state is entered immediately following a demand for the signal group, but after the minimum red state.",
        "DV8": "PASSIVE RED\nACTIVE RED"
    },
    "D": {
        "short": "Red priority",
        "long": "Signal group goes to red due to emergency priority. When this is the case, no other red states defined are used.",
        "DV8": "\"All\" RED states"
    },
    "E": {
        "short": "Red privilege",
        "long": "Signal group is in red state with permission to start. It may be part of the current defined stage. There is no demand for the signal group and a non-conflicting signal group within the same stage is being realized. When the signal group is not allowed to go to green due to a privilege timer configuration, this state will be left (Go to Passive red)",
        "DV8": "PASSIVE RED"
    },
    "F": {
        "short": "Red wait",
        "long": "The signal group is red with a demand to go to green and a conflicting group is still in green preventing the realization. The signal group is allowed to go to green in the current stage and will become green when the conflicting signal groups have gone to red and the clearance times have been obeyed.",
        "DV8": "ACTIVE RED"
    },
    "G": {
        "short": "Red stop",
        "long": "The signal group is in red with a demand to go to green. A conflicting group is preventing the realization. This state is entered when the last conflicting signal group has entered the amber state. The state persists until all clearance times have expired.",
        "DV8": "ACTIVE RED"
    },
    "H": {
        "short": "Inter-green/start-delay",
        "long": "The signal group is red with a demand to go to green and all clearance times have expired. The signal group is being delayed by another signal group with which it has a defined relation. The point which defines the relation has not yet been reached. Commonly the signal group on which it waits is in the red state waiting to go to green.",
        "DV8": "ACTIVE RED"
    },
    "I": {
        "short": "Fixed amber (start-up)",
        "long": "Fixed amber during start-up sequence",
        "DV8": "-"
    },
    "J": {
        "short": "Fixed red (start-up)",
        "long": "Fixed red during start-up sequence",
        "DV8": "-"
    }
};

export {
    stateDescriptions,
    greens,
    ambers,
    amberReds,
    reds,
    undefineds,
    GREEN,
    AMBER,
    AMBER_REDS,
    RED,
    UNDEF,
};
